<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Player')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="cnt">
            <FloatingLabel v-model="details.name" label="Name" size="sm"/>
            <FloatingLabel v-model="details.surname" label="Surname" size="sm"/>
            <FloatingLabel
              v-model="details.cnp"
              label="CNP"
              :state="isCNPValid"
              size="sm"
              aria-describedby="input-live-feedback"
            >
              <template v-slot:feedback>
                <div id="input-live-feedback" class="invalid-feedback">{{$t('Invalid CNP')}}</div>
              </template>
            </FloatingLabel>

            <b-form-group :label="$t('Blacklist this player')" class="grouping py-2 px-3 mb-3 mt-0">
              <b-form-checkbox
                v-model="details.blacklisted"
                :value="true"
                :unchecked-value="false"
              >{{$t('Blacklisted')}}</b-form-checkbox>
            </b-form-group>

            <div style="text-align:right">
              <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import validCNP from "@/shared/cnp";

export default {
  name: "player",
  props: ["selectedeid"],
  components: {
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      this.newId = true;
    }
  },
  data: function() {
    return {
      eid: "",
      details: {
        name: "",
        surname: "",
        cnp: "",
        blacklisted: false
      },
      newId: false,
      temp: {},
      isCNPValid: null
    };
  },
  watch: {
    "details.cnp": function(newVal) {
      this.isCNPValid = false;
      if (validCNP(newVal)) {
        this.isCNPValid = true;
      }
    }
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("player/read", this.eid)
        .then(resp => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "player/update";
      if (this.newId) {
        apiAction = "player/create";
      } else {
        detailsData.eid = this.eid;
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Player updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Player created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.name = r.name;
      this.details.surname = r.surname;
      this.details.cnp = r.cnp;
      if (typeof r.blacklisted != "undefined") {
        this.details.blacklisted = r.blacklisted;
      }
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Player", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
